<template>
  <svg fill="none" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 12H5" v-bind="$attrs" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 19L5 12L12 5" v-bind="$attrs" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
  export default {
    name: 'arrow-left'
  }
</script>



// WEBPACK FOOTER //
// src/ui/icon/ArrowLeft.vue